import { render } from "./Materials.vue?vue&type=template&id=f7f962d8&scoped=true&ts=true"
import script from "./Materials.vue?vue&type=script&lang=ts"
export * from "./Materials.vue?vue&type=script&lang=ts"

import "./Materials.vue?vue&type=style&index=0&id=f7f962d8&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f962d8"]])

export default __exports__